import React from 'react';
import { useTranslation } from 'react-i18next';
import ResetTextButton from '@/components/Approval/@components/ResetTextButton';
import { EmptyText, FooterWrap } from './styles';

type P = {
  /** 선택 수. 0이면 EmptyMessage, 1 이상이면 Reset 버튼. */
  count: number;
  emptyMessage: string;
  showReset: boolean;
  onReset?: () => void;
  disabled?: boolean;
};

/** 푸터 — 빈 메시지 또는 초기화 링크 */
const Footer = ({ count, emptyMessage, showReset, onReset, disabled }: P) => {
  const { t } = useTranslation();

  if (count === 0) {
    return (
      <FooterWrap $empty>
        <EmptyText>{emptyMessage}</EmptyText>
      </FooterWrap>
    );
  }

  if (!showReset) {
    return <FooterWrap />;
  }

  return (
    <FooterWrap>
      <ResetTextButton
        onClick={onReset}
        disabled={disabled}
        aria-label={t('참조인 초기화')}
      />
    </FooterWrap>
  );
};

export default Footer;
